import { createActionGroup, emptyProps, props } from "@ngrx/store";

export const DocViewerActions = createActionGroup({
	source: 'DocViewer',
	events: {
		'Loaded': emptyProps(),
		'Pdf Page Update': props<{ selectedPage: number }>(),
		'Save Requested': emptyProps()
	},
});
